import { render, staticRenderFns } from "./ReferralsView.vue?vue&type=template&id=79ac0273&scoped=true&"
import script from "./ReferralsView.vue?vue&type=script&lang=ts&"
export * from "./ReferralsView.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralsView.vue?vue&type=style&index=0&id=79ac0273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac0273",
  null
  
)

export default component.exports